import type { FormInstance } from '@arco-design/web-react';

import { getDeployPluginHeadless } from '../../../core/registry';
import type { PipelineContext } from '../../../core/types';
import type { DisplayConfigItem } from '../../../platform/display-descriptors';

/** innerForm → fresh displayConfig（经 registry pipeline） */
export function buildAppInstanceFreshDisplayConfig(innerForm: FormInstance, ctx: PipelineContext): DisplayConfigItem[] {
  try {
    return getDeployPluginHeadless('AppInstance').pipeline.prepareSkuSubmit(innerForm, ctx).displayConfig;
  } catch {
    return [];
  }
}

/** innerForm → sku resourceConfigs */
export function buildAppInstanceFreshResourceConfigs(innerForm: FormInstance, ctx: PipelineContext) {
  try {
    return getDeployPluginHeadless('AppInstance').pipeline.buildSkuResourceConfigs(innerForm, ctx);
  } catch {
    return [];
  }
}
